import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverPayRateDetails extends Layout {
    sourceDrsPayrate: DataSource;
    tableDriverPayRateDetails: Table;
}
